/**
 * The rounded slab that holds the hero and the workbench together on one
 * gradient ground, so the page opens with a single composition rather than a
 * headline followed by a widget.
 */
export function OpeningScene({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return <div className="opening-scene">{children}</div>;
}
